module.exports = __webpack_public_path__ + "img/2.7b31b5c7.png";